import script from "./CrudActividades.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudActividades.vue?vue&type=script&setup=true&lang=js"

import "./CrudActividades.vue?vue&type=style&index=0&id=f67e646a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f67e646a"]])

export default __exports__